import OpenNewIcon from '@mui/icons-material/OpenInNewRounded';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { accountsUtils } from 'app-components/flux/accounts';
import type { CashFlowTransaction } from 'app-components/flux/transactions/transactionsTypes';
import { DateTime } from 'luxon';
import type React from 'react';

import { useStyles } from '../styles';

type Props = {
  splitSeriesFf: boolean;
  txn: CashFlowTransaction;
};

function clickPayeeLink(name = '') {
  const url = `https://www.google.com/search?q=${encodeURIComponent(name)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export default function CardPaymentStatementNote({ splitSeriesFf, txn }: Props): React.JSX.Element | null {
  const { classes } = useStyles();
  const { cpData, type } = txn;
  if (!cpData) return null;
  if (!splitSeriesFf && type === 'PAYMENT') return null;

  const bankName = accountsUtils.getAccountString(txn.accountId);
  const displayDate = cpData.postedOn
    ? DateTime.fromFormat(cpData.postedOn || '', 'yyyy-M-d')
    : DateTime.fromISO(txn.postedOn);

  return (
    <Typography variant='captionRegular' color='textSecondary' display='block' className={classes.spacerRow}>
      {`Appears on your ${bankName} statement as `}
      <Link className={classes.link} id='statement-name-link' onClick={() => clickPayeeLink(cpData.payee)}>
        {cpData.payee}
        <OpenNewIcon fontSize='small' className={classes.openIcon} />
      </Link>
      {` on ${displayDate.toLocaleString(DateTime.DATE_MED)}. `}
    </Typography>
  );
}
